import React from "react";

const Tabs = ({ tabs, activeTab, setActiveTab, fullWidth = false }) => {
  return (
    <div
      className={`flex h-16 ${
        fullWidth ? "w-full" : "justify-center"
      } mb-2 border-b border-gray-300`}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`${
            fullWidth
              ? "flex-1 flex items-center justify-center"
              : "px-16 relative"
          } py-2 font-medium text-center ${
            activeTab === tab.id
              ? "text-primary border-b-2 border-primary"
              : "text-gray-600"
          }`}
        >
          {fullWidth ? (
            tab.label
          ) : (
            <span className="absolute bottom-2 left-1/2 transform -translate-x-1/2">
              {tab.label}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
